import { render, staticRenderFns } from "./NewPaymentsCreate.vue?vue&type=template&id=19e72887&scoped=true"
import script from "./NewPaymentsCreate.vue?vue&type=script&lang=js"
export * from "./NewPaymentsCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e72887",
  null
  
)

export default component.exports